import { Info } from "lucide-react";
import { useState } from "react";
const Tooltip = ({ text, children }) => {
  const [visible, setVisible] = useState(false);

  const toggleTooltip = () => setVisible(!visible);

  return (
    <div className="relative inline-block">
      <div
        className="cursor-pointer flex items-center gap-1"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onClick={toggleTooltip} // works for mobile
      >
        {children}
        <Info size={16} className="text-slate-500" />
      </div>

      {visible && (
        <div className="absolute z-[9999] w-56 p-2 mt-2 text-xs text-white bg-gray-800 rounded-lg shadow-lg left-1/2 -translate-x-1/2">
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
